module.exports = __webpack_public_path__ + "img/urban.79aaee3.webp";